export const PAGES = {
  "sivas-masaj-salonu": {
    path: "/sivas-masaj-salonu",
    title: "Sivas Masaj Salonu | Lunessa Spa Masaj",
    description:
      "Sivas masaj salonu Lunessa Spa Masaj; hijyenik ortamı, profesyonel hizmet anlayışı ve konforlu odalarıyla Sivas Merkez'de. Masaj randevusu için hemen arayın.",
    eyebrow: "Sivas Merkez",
    h1: "Sivas Masaj Salonu",
    intro:
      "Kızılırmak Mahallesi'ndeki salonumuzda, şehrin temposundan uzaklaşıp kendinize zaman ayırabileceğiniz sakin bir alan sunuyoruz.",
    image: "/images/lunessa-sivas-masaj-odasi-2.webp",
    imageAlt: "lunessa-sivas-masaj-salonu",
    sections: [
      {
        h2: "Sivas’ta Profesyonel Masaj Deneyimi",
        body: `Gün içinde ekran başında geçen saatler, trafikte harcanan zaman ve bitmek bilmeyen sorumluluklar zamanla bedende de zihinde de yorgunluk bırakır. Lunessa Spa Masaj, Sivas'ta bu yorgunluğu geride bırakmak isteyenler için tasarlanmış bir masaj salonudur. Kapıdan içeri adım attığınız andan itibaren loş ışık, hafif bir koku ve sakin bir müzik sizi karşılar. Amacımız, birkaç saatliğine de olsa kendinizi tamamen rahat hissedeceğiniz bir ortam yaratmaktır.

Profesyonel masaj deneyimi yalnızca uygulanan tekniklerden ibaret değildir. Misafirimizi nasıl karşıladığımız, odanın nasıl hazırlandığı, seans öncesinde ihtiyaçlarınızın nasıl dinlendiği ve seans sonrasında size nasıl zaman tanındığı, bütün deneyimin parçasıdır. Lunessa'da her seans, bu detayların hepsi düşünülerek planlanır.

### Kişiye Özel Yaklaşım

Her bedenin ve her günün ihtiyacı farklıdır. Bu yüzden seans başlamadan önce kısa bir görüşme yapıyor; baskı tercihinizi, yorgunluk hissettiğiniz bölgeleri ve masajdan beklentinizi öğreniyoruz. Böylece klasik bir rahatlama seansı mı, yoksa omuz ve boyun bölgesine odaklanan daha yoğun bir uygulama mı istediğinizi birlikte belirliyoruz.`,
      },
      {
        h2: "Sivas Masaj Salonu Seçerken Nelere Dikkat Edilmeli?",
        body: `Bir masaj salonu seçerken yalnızca fiyat ya da konum değil, salonun genel anlayışı da önemlidir. Kendinizi emanet edeceğiniz yerin temiz, düzenli ve güven veren bir ortam olması, deneyimin kalitesini doğrudan etkiler. Sivas'ta masaj salonu ararken aşağıdaki noktalara dikkat etmenizi öneririz.

### Hijyen ve Temizlik

Temiz havlular, her misafir için yenilenen örtüler, düzenli havalandırılan odalar ve bakımlı ekipmanlar olmazsa olmazdır. Lunessa'da hijyen bir tercih değil, standarttır. Her seansın ardından oda yeniden hazırlanır; jakuzi ve sauna alanlarının temizliği düzenli olarak yapılır.

### Ortamın Konforu

Masajın etkisini artıran en önemli unsurlardan biri ortamdır. Oda sıcaklığı, ışık düzeni, ses yalıtımı ve masaj masalarının konforu, kendinizi bırakabilmeniz için büyük önem taşır. Salonumuzdaki odalar bu ihtiyaçlar düşünülerek düzenlenmiştir.

### Şeffaf İletişim ve Kolay Randevu

Hangi hizmetlerin sunulduğunu, seansların ne kadar sürdüğünü ve randevunun nasıl alınacağını kolayca öğrenebilmeniz gerekir. Telefonla ya da WhatsApp üzerinden bize ulaşarak tüm sorularınıza hızlıca yanıt alabilirsiniz.`,
      },
      {
        h2: "Lunessa Spa Masaj Hizmetleri",
        body: `Salonumuzda farklı ihtiyaçlara yanıt veren geniş bir hizmet yelpazesi sunuyoruz. Tüm vücudu kapsayan [klasik masaj](/hizmet/klasik-masaj), Uzak Doğu esintili [Bali masajı](/hizmet/bali-masaji) ve [Thai masajı](/hizmet/thai-masaji), gerginlik hissedilen bölgelere odaklanan [medikal masaj](/hizmet/medikal-masaj), aktif yaşam sürenler için [sporcu masajı](/hizmet/sporcu-masaji) bunlardan yalnızca birkaçı. Daha uzun ve ayrıcalıklı bir deneyim arayanlar için Sultan ve Osmanlı masajı ritüellerimiz, masaj sonrası dinlenmek isteyenler için ise sauna ve jakuzi alanlarımız bulunuyor.

Hangi masajın size uygun olduğundan emin değilseniz endişelenmeyin. Ekibimiz, beklentilerinizi dinledikten sonra size en uygun seçeneği önermekten memnuniyet duyar. Masaj türleri hakkında daha ayrıntılı bilgi almak için [Sivas masaj](/sivas-masaj) sayfamızı inceleyebilirsiniz.

### Tüm Paketlerde Kampanya

Dönemsel kampanyalarımızla, seçtiğiniz masaj paketlerinde avantajlı fiyatlardan yararlanabilirsiniz. Güncel kampanya bilgisi için bize WhatsApp üzerinden yazmanız yeterli.`,
      },
      {
        h2: "Sivas Masaj Randevusu Nasıl Alınır?",
        body: `Lunessa Spa Masaj'da randevu almak oldukça kolaydır. Size en uygun gün ve saati belirlemek için birkaç yoldan bize ulaşabilirsiniz.

### Telefonla Randevu

0535 795 20 58 numaralı telefondan bizi arayarak dilediğiniz hizmet için hızlıca randevu oluşturabilirsiniz. Telefonda hizmetlerimiz, seans süreleri ve güncel kampanyalar hakkında da bilgi alabilirsiniz.

### WhatsApp ile Randevu

Arama yapmak yerine yazmayı tercih ediyorsanız sayfadaki WhatsApp butonuna dokunmanız yeterli. Mesajınıza en kısa sürede dönüş yaparak uygun saatleri paylaşıyoruz. Randevunuza birkaç dakika erken gelmeniz, seansa sakin bir şekilde başlamanızı sağlar.

### Randevu Öncesi Küçük Öneriler

Masajdan hemen önce ağır yemek yememenizi, yanınızda rahat kıyafet bulundurmanızı ve varsa sağlık durumunuzla ilgili bilgileri seans öncesinde paylaşmanızı öneririz. Böylece size en uygun uygulamayı planlayabiliriz.`,
      },
      {
        h2: "Sivas Merkez’de Masaj Salonu",
        body: `Lunessa Spa Masaj, Kızılırmak Mahallesi 27. Sokak No:2B adresinde, Sivas Merkez'de kolayca ulaşılabilecek bir konumdadır. İş çıkışı, alışveriş arasında ya da hafta sonu kısa bir mola vermek istediğinizde salonumuza rahatlıkla gelebilirsiniz.

Merkezi konumumuz sayesinde şehrin farklı noktalarından ulaşım kolaydır. Haritadaki "Yol Tarifi Al" bağlantısını kullanarak bulunduğunuz yerden salonumuza en kısa rotayı öğrenebilirsiniz. Spa deneyimini masajla birlikte yaşamak isterseniz [Sivas spa](/sivas-spa) sayfamıza göz atabilir, tüm iletişim bilgilerimiz için [iletişim](/iletisim) sayfasını ziyaret edebilirsiniz.

Lunessa'da bizim için en değerli şey, salonumuzdan ayrılırken yüzünüzde beliren o rahat ifadedir. Sivas'ta güvenle tercih edebileceğiniz bir masaj salonu arıyorsanız sizi ağırlamaktan mutluluk duyarız.`,
      },
    ],
    showServices: true,
  },

  "sivas-masaj": {
    path: "/sivas-masaj",
    title: "Sivas Masaj | Lunessa Spa Masaj",
    description:
      "Sivas masaj hizmetleri: klasik, Bali, Thai, medikal, sporcu ve daha fazlası Lunessa Spa Masaj'da. Size uygun masaj türünü keşfedin, WhatsApp'tan randevu alın.",
    eyebrow: "Masaj Rehberi",
    h1: "Sivas Masaj Hizmetleri",
    intro:
      "Hangi masaj size iyi gelir? Sivas'ta sunduğumuz masaj türlerini, farklarını ve kimler için uygun olduklarını sizin için derledik.",
    image: "/images/sivas-klasik-masaj.webp",
    imageAlt: "lunessa-sivas-masaj-hizmetleri",
    sections: [
      {
        h2: "Masaj Neden İyi Gelir?",
        body: `Masaj, insanlık tarihinin en eski bakım yöntemlerinden biridir. Farklı kültürlerde farklı isimlerle anılsa da temel amacı hep aynıdır: bedeni rahatlatmak, zihni sakinleştirmek ve kişinin kendine yeniden zaman ayırmasını sağlamak. Günümüzün hızlı yaşam temposunda masaj, bir lüksten çok kendimize gösterdiğimiz özenin bir parçası haline geldi.

Sivas'ta masaj hizmeti arayan misafirlerimizin büyük bölümü benzer şeylerden söz eder: uzun çalışma saatleri, omuzlarda biriken gerginlik, yorgun bacaklar ve dinlenmeye bir türlü vakit ayıramamak. Lunessa Spa Masaj, tam da bu ihtiyaçlar için sakin ve güvenli bir alan sunar. Salonumuzun genel yaklaşımını merak ediyorsanız [Sivas masaj salonu](/sivas-masaj-salonu) sayfamızı okuyabilirsiniz.

### Bir Bakım Rutini Olarak Masaj

Düzenli aralıklarla yapılan masaj seansları, kendinize ayırdığınız zamanın bir alışkanlık haline gelmesini sağlar. Ayda bir ya da iki kez kısa bir mola vermek bile haftanın temposunu daha keyifli karşılamanıza yardımcı olabilir.`,
      },
      {
        h2: "Sivas’ta Sunduğumuz Masaj Türleri",
        body: `Lunessa'da her ihtiyaca ve her tercihe uygun bir masaj seçeneği bulmanız mümkün. Aşağıda en çok tercih edilen masaj türlerimizi kısaca tanıtıyoruz.

### Rahatlatıcı Masajlar

[Klasik masaj](/hizmet/klasik-masaj), uzun ve akıcı hareketlerle tüm vücudu kapsayan dengeli bir deneyimdir; ilk kez masaj yaptıracaklar için idealdir. [Soft masaj](/hizmet/soft-masaj) ise hafif baskı ve yumuşak dokunuşlarla uygulanır; yoğun baskı istemeyen misafirlerimizin tercihidir.

### Uzak Doğu Kökenli Masajlar

[Bali masajı](/hizmet/bali-masaji), aromatik yağlar ve yavaş ritimli hareketlerle zihni de dinlendiren bir ritüeldir. [Thai masajı](/hizmet/thai-masaji) ise germe ve esneme hareketlerinin öne çıktığı, pasif bir yoga deneyimini andıran geleneksel bir uygulamadır.

### Odaklı ve Dinamik Masajlar

[Medikal masaj](/hizmet/medikal-masaj), boyun, omuz ve sırt gibi gerginlik hissedilen bölgelere daha kontrollü baskılarla odaklanır. [Sporcu masajı](/hizmet/sporcu-masaji), aktif yaşam sürenler ve düzenli spor yapanlar için daha canlı bir tempoyla uygulanır. [Terapötik masaj](/hizmet/terapotik-masaj) ise farklı teknikleri kişinin o günkü ihtiyacına göre harmanlayan bütüncül bir seanstır.

### Geleneksel Ritüeller

Anadolu'nun köklü bakım kültüründen ilham alan [Osmanlı masajı](/hizmet/osmanli-masaji) ve saray geleneklerinin zarafetini taşıyan [Sultan masajı](/hizmet/sultan-masaji), daha uzun ve ayrıcalıklı bir deneyim arayan misafirlerimiz için hazırlanmıştır.`,
      },
      {
        h2: "Size Uygun Masajı Nasıl Seçersiniz?",
        body: `Masaj seçimi, beklentinize ve o günkü ihtiyacınıza bağlıdır. Sadece rahatlamak ve uzun bir günün yorgunluğunu atmak istiyorsanız klasik ya da soft masaj iyi bir başlangıçtır. Omuz ve boyun bölgesinde belirgin bir gerginlik hissediyorsanız medikal masaj daha uygun olabilir. Spor sonrası dinlenmek istiyorsanız sporcu masajını, farklı bir kültürü deneyimlemek istiyorsanız Bali ya da Thai masajını tercih edebilirsiniz.

### Baskı Seviyesi

Her masajda baskı seviyesi sizin tercihinize göre ayarlanabilir. Seans sırasında rahatsız olduğunuz bir an olursa bunu çekinmeden belirtmeniz yeterlidir. Konforunuz bizim için her zaman önceliklidir.

### Seans Süresi

Masaj sürelerimiz genellikle 45 ile 75 dakika arasında değişir. İlk deneyiminiz için 50 dakikalık bir seans, ritüel tadında bir deneyim için ise daha uzun süreli paketler önerilir.`,
      },
      {
        h2: "Masaj Öncesi ve Sonrası Öneriler",
        body: `Masajdan en iyi şekilde yararlanmak için seanstan önce hafif beslenmenizi, randevunuza birkaç dakika erken gelmenizi ve telefonunuzu sessize almanızı öneririz. Seans sonrasında bol su içmek ve kısa bir süre dinlenmek de deneyimi tamamlar.

Masajın ardından spa keyfini sürdürmek isterseniz sauna ve jakuzi alanlarımızdan yararlanabilirsiniz. Spa hizmetlerimiz hakkında ayrıntılı bilgiye [Sivas spa](/sivas-spa) sayfamızdan ulaşabilirsiniz. Hamilelik, kronik rahatsızlık ya da yakın zamanda geçirilmiş bir operasyon gibi durumlarda masaj öncesinde doktorunuza danışmanızı öneririz.

### Randevu İçin

Sivas'ta masaj randevusu almak için bizi telefonla arayabilir ya da WhatsApp üzerinden mesaj gönderebilirsiniz. Size en uygun gün ve saati birlikte belirleyelim.`,
      },
    ],
    showServices: true,
  },

  "sivas-spa": {
    path: "/sivas-spa",
    title: "Sivas Spa | Lunessa Spa Masaj",
    description:
      "Sivas spa deneyimi Lunessa Spa Masaj'da: masaj, sauna ve jakuzi bir arada. Hijyenik ve huzurlu ortamda kendinize zaman ayırın, hemen randevu alın.",
    eyebrow: "Spa Deneyimi",
    h1: "Sivas Spa ve Masaj",
    intro:
      "Masaj, sauna ve jakuzinin bir araya geldiği bütüncül bir dinlenme deneyimi. Sivas'ta spa keyfini Lunessa'nın sakin atmosferinde yaşayın.",
    image: "/images/lunessa-sivas-jakuzi-masaj-odasi.webp",
    imageAlt: "lunessa-sivas-spa-jakuzi",
    sections: [
      {
        h2: "Spa Nedir, Neden Tercih Edilir?",
        body: `Spa kelimesi, kökeni yüzyıllar öncesine dayanan su ve dinlenme kültürünü ifade eder. Günümüzde spa denince akla; masaj, sauna, jakuzi ve beden bakımının bir arada sunulduğu, kişinin kendine zaman ayırdığı huzurlu mekânlar gelir. Spa deneyimi, tek bir uygulamadan çok, bütün bir günün ya da birkaç saatin size ayrılmasıdır.

Sivas'ta spa hizmeti arayanlar için Lunessa Spa Masaj, masaj odalarıyla bütünleşik jakuzi alanı ve sauna imkânıyla eksiksiz bir dinlenme deneyimi sunar. Burada amaç, yalnızca bir seans almak değil; şehrin gürültüsünden uzaklaşıp bedeninize ve zihninize gerçek bir mola vermektir.

### Kendinize Ayırdığınız Zaman

Spa ziyareti, yoğun bir haftanın ardından kendinizi ödüllendirmenin en keyifli yollarından biridir. Telefonları bir kenara bıraktığınız, sadece nefesinize ve bedeninize odaklandığınız birkaç saat, haftanın geri kalanına çok daha dinlenmiş başlamanızı sağlar.`,
      },
      {
        h2: "Lunessa’da Spa Deneyimi",
        body: `Lunessa'da spa deneyimi, karşılama anından itibaren başlar. Sizi sakin bir ortamda ağırlıyor, tercih ettiğiniz hizmetleri konuşuyor ve deneyiminizi ihtiyaçlarınıza göre planlıyoruz.

### Sauna ile Isınma

Pek çok misafirimiz deneyimine [sauna](/hizmet/sauna) ile başlamayı tercih eder. Kuru sıcaklık bedeni ısıtır, zihni yavaşlatır ve masaja hazırlar. Kısa sauna oturumlarının ardından ılık bir duş, deneyimin ilk adımını tamamlar.

### Masaj ile Rahatlama

Isınan beden, masajın etkisini daha derinden hisseder. Bu aşamada klasik, Bali, Osmanlı ya da Sultan masajı gibi seçeneklerden birini tercih edebilirsiniz. Hangi masajın size uygun olduğunu öğrenmek için [masaj hizmetleri](/masaj-hizmetleri) sayfamızı inceleyebilirsiniz.

### Jakuzi ile Dinlenme

Masajın ardından ılık suyun ve hafif kabarcıkların keyfini [jakuzi](/hizmet/jakuzi) alanımızda çıkarabilirsiniz. Masaj odalarımızla bütünleşik jakuzi, deneyiminizi aynı sakin atmosferde sürdürmenizi sağlar.`,
      },
      {
        h2: "Spa ve Masajı Bir Arada Yaşamanın Avantajları",
        body: `Masajı tek başına almak da keyiflidir; ancak sauna ve jakuzi ile birleştiğinde deneyim çok daha bütünlüklü hale gelir. Sıcaklık, su ve dokunuşun bir araya gelmesi, kendinizi daha hafif ve dinlenmiş hissetmenize yardımcı olur.

### Çiftler İçin Spa

Çift masa bulunan odalarımız sayesinde eşiniz, arkadaşınız ya da aile üyenizle birlikte spa deneyimi yaşayabilirsiniz. Özel günlerde birlikte geçirilen sakin bir saat, unutulmaz bir hediyeye dönüşebilir.

### Hijyen ve Güven

Spa deneyiminde en önemli konulardan biri hijyendir. Jakuzi ve sauna alanlarımız düzenli olarak temizlenir, her misafir için temiz havlu ve örtü kullanılır. Kendinizi güvende hissetmeniz, rahatlayabilmenizin ilk şartıdır.`,
      },
      {
        h2: "Sivas’ta Spa Keyfi İçin Öneriler",
        body: `Spa ziyaretinizden en iyi şekilde yararlanmak için birkaç küçük öneri paylaşmak isteriz. Ziyaretinizden önce ağır yemeklerden kaçının ve bol su için. Sauna ve jakuzi sürelerini kısa tutun; aralarda dinlenmeyi ihmal etmeyin. Tansiyon, kalp rahatsızlığı gibi sağlık durumlarınız veya hamilelik söz konusuysa sıcak uygulamalardan önce doktorunuza danışın.

### Ne Zaman Gelmeli?

Hafta içi akşam saatleri iş çıkışı rahatlamak için, hafta sonu öğleden sonraları ise acele etmeden uzun bir spa deneyimi yaşamak için idealdir. Yoğun dönemlerde yerinizi garantilemek için önceden randevu almanızı öneririz.

Sivas'ta spa merkezi olarak sunduğumuz olanaklar hakkında daha fazla bilgi için [Sivas spa merkezi](/sivas-spa-merkezi) sayfamızı inceleyebilir, tüm hizmetlerimizi [masaj hizmetleri](/masaj-hizmetleri) sayfasında görebilirsiniz.`,
      },
    ],
    showServices: true,
  },

  "sivas-spa-merkezi": {
    path: "/sivas-spa-merkezi",
    title: "Sivas Spa Merkezi | Lunessa Spa Masaj",
    description:
      "Sivas spa merkezi Lunessa Spa Masaj: masaj odaları, sauna, jakuzi ve konforlu dinlenme alanları Sivas Merkez'de. Olanaklarımızı keşfedin, randevu alın.",
    eyebrow: "Olanaklarımız",
    h1: "Sivas Spa Merkezi",
    intro:
      "Salonumuzun alanlarını, hijyen standartlarımızı ve bir ziyaretin adım adım nasıl geçtiğini merak edenler için hazırladık.",
    image: "/images/lunessa-sivas-spa-salonu-dis-cephe.webp",
    imageAlt: "lunessa-sivas-spa-merkezi",
    sections: [
      {
        h2: "Sivas’ta Bir Spa Merkezinden Ne Beklemelisiniz?",
        body: `İyi bir spa merkezi; temiz, ferah ve iyi düzenlenmiş alanlara, güler yüzlü bir ekibe ve misafirin konforunu her şeyin önünde tutan bir anlayışa sahip olmalıdır. Sivas'ta spa merkezi arayan misafirlerimizin en çok sorduğu sorular da genellikle bu konular üzerinedir: Ortam temiz mi? Odalar rahat mı? Randevu almak kolay mı? Ulaşım nasıl?

Lunessa Spa Masaj olarak bu soruların her birine açık yanıtlar verebilmek için salonumuzu en ince ayrıntısına kadar düşünerek tasarladık. Bu sayfada, ziyaretinizden önce bilmek isteyebileceğiniz her şeyi bulacaksınız.`,
      },
      {
        h2: "Spa Merkezimizin Alanları",
        body: `Salonumuz, farklı ihtiyaçlara hizmet eden alanlardan oluşur. Her alan, kendi işlevine uygun şekilde ve sakin bir bütünlük içinde düzenlenmiştir.

### Karşılama ve Dinlenme Alanı

Salona girdiğiniz anda sizi sıcak bir karşılama ve rahat bir bekleme alanı karşılar. Burada seans öncesinde birkaç dakika soluklanabilir, ekibimizle tercihlerinizi konuşabilirsiniz.

### Masaj Odaları

Masaj odalarımız tek ve çift masa seçenekleriyle düzenlenmiştir. Ayarlanabilir ışıklandırma, konforlu masaj masaları ve sessiz bir ortam, seans boyunca kendinizi tamamen bırakmanızı sağlar. Çift masalı odalarımız, birlikte masaj yaptırmak isteyen misafirlerimiz için idealdir.

### Jakuzi ve Sauna

Masaj odalarıyla bütünleşik jakuzi alanımız, seans sonrasında aynı sakin ortamda dinlenmeye devam etmenize olanak tanır. [Sauna](/hizmet/sauna) ise masaj öncesinde bedeni ısıtmak için tercih edilir. [Jakuzi](/hizmet/jakuzi) ve sauna kullanımı, masaj paketlerinizle birlikte planlanabilir.`,
      },
      {
        h2: "Hijyen Standartlarımız",
        body: `Bir spa merkezinde hijyen, misafir güveninin temelidir. Lunessa'da uyguladığımız standartlar, her ziyaretin aynı özenle karşılanmasını sağlar.

### Her Misafir İçin Yenilenen Malzemeler

Havlular, örtüler ve kullanılan tüm tekstil ürünleri her misafir için yenilenir. Masaj masaları ve yüzeyler her seans sonrasında temizlenir.

### Düzenli Bakım

Jakuzi ve sauna alanlarının temizliği ve teknik bakımı düzenli olarak yapılır. Odalar her seansın ardından havalandırılır ve bir sonraki misafir için yeniden hazırlanır.

### Kaliteli Ürünler

Masajlarda kullanılan yağlar ve bakım ürünleri özenle seçilir. Hassasiyetiniz ya da alerjiniz varsa seans öncesinde bize bildirmeniz yeterlidir.`,
      },
      {
        h2: "Bir Ziyaret Adım Adım Nasıl Geçer?",
        body: `İlk kez spa merkezine gelecek misafirlerimiz için ziyaretin nasıl ilerlediğini kısaca anlatmak isteriz.

### 1. Randevu

Telefon ya da WhatsApp üzerinden size uygun gün ve saati belirliyoruz. Bu aşamada hangi hizmeti almak istediğinizi de konuşabiliriz.

### 2. Karşılama

Randevu saatinizden birkaç dakika önce salonumuza geldiğinizde sizi karşılıyor, kısa bir ön görüşme yapıyoruz.

### 3. Seans

Hazırlanan odanızda, seçtiğiniz masaj ya da spa hizmeti uygulanır. Seans boyunca konforunuz önceliğimizdir.

### 4. Dinlenme

Seansın ardından acele etmeden dinlenebilir, dilerseniz jakuzi veya sauna ile deneyiminizi tamamlayabilirsiniz.`,
      },
      {
        h2: "Merkezi Konum ve Kolay Ulaşım",
        body: `Spa merkezimiz Kızılırmak Mahallesi 27. Sokak No:2B, Merkez/Sivas adresindedir. Şehrin merkezinde yer aldığımız için toplu taşıma ya da özel araçla kolayca ulaşabilirsiniz. Harita üzerindeki yol tarifi bağlantısı ile bulunduğunuz yerden salonumuza en hızlı şekilde gelebilirsiniz.

Spa deneyiminin masajla nasıl bütünleştiğini merak ediyorsanız [Sivas spa](/sivas-spa) sayfamızı, salonumuzun genel yaklaşımı için [Sivas masaj salonu](/sivas-masaj-salonu) sayfamızı okuyabilirsiniz. Tüm iletişim bilgilerimiz [iletişim](/iletisim) sayfasında yer alıyor.`,
      },
    ],
    showServices: false,
  },

  "masaj-hizmetleri": {
    path: "/masaj-hizmetleri",
    title: "Masaj Hizmetleri Sivas | Lunessa Spa Masaj",
    description:
      "Sivas masaj hizmetleri: Klasik, Bali, Medikal, Sporcu, Thai, Terapötik, Soft, Sultan, Osmanlı masajı, sauna ve jakuzi. Tüm paketlerde kampanya, hemen randevu alın.",
    eyebrow: "Hizmetlerimiz",
    h1: "Masaj Hizmetlerimiz",
    intro:
      "Kendinize zaman ayırın, Lunessa’nın rahatlatıcı masaj deneyimiyle yenilenin. Tüm hizmetlerimizi tek sayfada inceleyin.",
    image: "/images/sivas-bali-masaji.webp",
    imageAlt: "lunessa-sivas-masaj-hizmetleri",
    sections: [
      {
        h2: "Her İhtiyaca Uygun Bir Masaj",
        body: `Lunessa Spa Masaj'da sunduğumuz hizmetler, farklı beklentilere ve farklı yaşam tarzlarına yanıt verecek şekilde hazırlanmıştır. Kimi misafirimiz sadece uzun bir günün ardından dinlenmek ister, kimi düzenli spor sonrası kaslarını rahatlatmayı, kimi de özel bir günde kendini şımartmayı. Hangi ihtiyaçla gelirseniz gelin, size uygun bir seçenek bulmanız için buradayız.

Her hizmetimizin kendine ait bir sayfası bulunur. Bu sayfalarda masajın nasıl uygulandığını, kimler için uygun olduğunu ve seans süresini bulabilirsiniz. Masaj türleri arasındaki farkları genel olarak öğrenmek isterseniz [Sivas masaj](/sivas-masaj) rehberimize göz atabilirsiniz.`,
      },
    ],
    afterSections: [
      {
        h2: "Hizmet Seçerken Yardıma mı İhtiyacınız Var?",
        body: `Hangi masajın size iyi geleceğinden emin değilseniz bize yazmanız yeterli. Beklentilerinizi ve varsa hassasiyetlerinizi dinleyerek size en uygun hizmeti önerelim. Tüm paketlerimizde geçerli dönemsel kampanyalar hakkında da bilgi alabilirsiniz.

### Randevu ve İletişim

Randevu için 0535 795 20 58 numaralı telefondan bizi arayabilir ya da WhatsApp üzerinden mesaj gönderebilirsiniz. Adres ve yol tarifi bilgilerimiz [iletişim](/iletisim) sayfasında yer alıyor. Spa deneyimini masajla birlikte yaşamak isterseniz [Sivas spa](/sivas-spa) sayfamızı da inceleyebilirsiniz.`,
      },
    ],
    showServices: true,
  },

  hakkimizda: {
    path: "/hakkimizda",
    title: "Lunessa Spa Masaj Hakkında | Sivas",
    description:
      "Lunessa Spa Masaj hakkında: Sivas Merkez'de hijyen, konfor ve profesyonel hizmet anlayışıyla masaj ve spa deneyimi sunan salonumuzu yakından tanıyın.",
    eyebrow: "Hakkımızda",
    h1: "Lunessa Spa Masaj Hakkında",
    intro: "Sivas’ta huzur ve yenilenmenin adresi olmak için yola çıktık.",
    image: "/images/lunessa-sivas-spa-salonu-dis-cephe.webp",
    imageAlt: "lunessa-sivas-spa-masaj-salonu-dis-cephe",
    sections: [
      {
        h2: "Hikâyemiz",
        body: `Lunessa Spa Masaj, Sivas'ta insanların kendilerine gerçekten zaman ayırabilecekleri, güvenle ve rahatlıkla gelebilecekleri bir mekân yaratma isteğiyle kuruldu. Adını ayın sakin ışığından alan Lunessa, şehrin hızlı temposunun ortasında yumuşak ve dingin bir mola noktası olmayı amaçlar.

Kızılırmak Mahallesi'ndeki salonumuzu tasarlarken her detayı misafirlerimizin konforunu düşünerek planladık. Karşılama alanından masaj odalarına, jakuzi alanından kullandığımız havlulara kadar her şeyin aynı özeni yansıtmasını istedik.`,
      },
      {
        h2: "Değerlerimiz",
        body: `Lunessa'nın temelinde üç değer yer alır: hijyen, konfor ve misafir memnuniyeti.

### Hijyen

Temizlik bizim için pazarlık konusu değildir. Her misafir için yenilenen havlu ve örtüler, düzenli temizlenen jakuzi ve sauna alanları, havalandırılan odalar standart uygulamalarımızdır.

### Konfor

Işıktan sıcaklığa, müzikten masaj masalarına kadar her unsur, kendinizi bırakabilmeniz için düzenlenmiştir.

### Misafir Memnuniyeti

Her misafirimizin ihtiyacını dinliyor, deneyimi ona göre şekillendiriyoruz. Salonumuzdan memnun ayrılmanız ve yeniden gelmek istemeniz en büyük motivasyonumuzdur.`,
      },
      {
        h2: "Sivas’ta Sunduğumuz Hizmetler",
        body: `Klasik masajdan Bali ve Thai masajına, medikal ve sporcu masajından Sultan ve Osmanlı ritüellerine kadar geniş bir hizmet yelpazesi sunuyoruz. Sauna ve jakuzi alanlarımızla da masaj deneyiminizi bir spa ziyaretine dönüştürebilirsiniz. Tüm hizmetlerimizi [masaj hizmetleri](/masaj-hizmetleri) sayfasında, salonumuzun yaklaşımını ise [Sivas masaj salonu](/sivas-masaj-salonu) sayfasında bulabilirsiniz.

Sizi Lunessa'da ağırlamaktan mutluluk duyarız. Randevu ve bilgi için [iletişim](/iletisim) sayfamızı ziyaret edebilir, salonumuzdan kareleri [galeri](/galeri) sayfasında inceleyebilirsiniz.`,
      },
    ],
    showServices: false,
  },
};

export const WHY_ITEMS = [
  { icon: "Sparkles", title: "Hijyenik Ortam", text: "Her misafir için yenilenen havlu ve örtüler, düzenli temizlenen odalar, jakuzi ve sauna alanları." },
  { icon: "Award", title: "Profesyonel Hizmet", text: "İhtiyaçlarınızı dinleyen, her seansı özenle planlayan deneyimli bir yaklaşım." },
  { icon: "Flower2", title: "Konforlu Atmosfer", text: "Yumuşak ışık, sakin müzik ve rahat masaj masalarıyla kendinizi bırakabileceğiniz bir ortam." },
  { icon: "CalendarCheck", title: "Kolay Randevu", text: "Telefonla ya da WhatsApp üzerinden birkaç dakikada size uygun saate randevu alın." },
  { icon: "MapPin", title: "Merkezi Konum", text: "Kızılırmak Mahallesi'nde, Sivas Merkez'in her noktasından kolayca ulaşılabilen adres." },
  { icon: "HeartHandshake", title: "Misafir Memnuniyeti", text: "Salonumuzdan rahatlamış ve memnun ayrılmanız, her gün yeniden çalışmamızın nedeni." },
];
